/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Refresh_Still_PublishingInputs */

const vi_einvoice_refresh_still_publishing = /** @type {(inputs: Einvoice_Refresh_Still_PublishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA đang ký hóa đơn. Hệ thống sẽ tự cập nhật trong vài phút, không cần phát hành lại.`)
};

/**

* @param {Einvoice_Refresh_Still_PublishingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_refresh_still_publishing = /** @type {((inputs?: Einvoice_Refresh_Still_PublishingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Refresh_Still_PublishingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_refresh_still_publishing(inputs)
});